<template>
	<div class="addr-msg-page">
		<!-- ===== 页面顶部条 ===== -->
		<div class="page-top-bar animate__animated animate__fadeIn">
			<div class="welcome-text">
				<span class="wel-gray">HI&nbsp;欢迎进入</span>
				<span class="wel-blue">至隆科技物流系统</span>
			</div>
			<div class="top-actions">
				<span class="lang-text">中文</span>
				<el-image :src="require('@/static/CodeBuddyAssets/30858_5246/7.svg')"></el-image>
				<el-image class="action-gap" :src="require('@/static/CodeBuddyAssets/30858_5246/5.svg')"></el-image>
				<el-image :src="require('@/static/CodeBuddyAssets/30858_5246/28.svg')"></el-image>
				<span class="user-name">张德帅</span>
				<span class="member-no">会员编号：25005050</span>
				<el-image class="action-gap" :src="require('@/static/CodeBuddyAssets/30858_5246/5.svg')"></el-image>
				<el-image :src="require('@/static/CodeBuddyAssets/30858_5246/2.svg')"></el-image>
				<el-image class="cart-badge" :src="require('@/static/CodeBuddyAssets/30858_5246/3.svg')"></el-image>
				<el-image :src="require('@/static/CodeBuddyAssets/30858_5246/1.svg')"></el-image>
				<el-image :src="require('@/static/CodeBuddyAssets/30858_5246/6.svg')"></el-image>
			</div>
		</div>

		<!-- ===== 面包屑 + 返回 ===== -->
		<div class="breadcrumb-bar animate__animated animate__fadeIn">
			<div class="bc-left">
				<span class="bc-label">当前位置：</span>
				<span class="bc-item">快件下单</span>
				<el-image class="bc-arrow" :src="require('@/static/CodeBuddyAssets/30858_5246/24.svg')"></el-image>
				<span class="bc-item">选择地址</span>
				<el-image class="bc-arrow" :src="require('@/static/CodeBuddyAssets/30858_5246/25.svg')"></el-image>
				<span class="bc-item bc-active">新增收件人</span>
			</div>
			<div class="bc-right">
				<span class="bc-back-text">返回</span>
				<el-image class="bc-back-icon" :src="require('@/static/CodeBuddyAssets/30858_5246/8.svg')"></el-image>
			</div>
		</div>

		<!-- ===== 表单卡片 ===== -->
		<div class="form-card animate__animated  ">
			<!-- 表单标题 -->
			<div class="form-title-row">
				<el-image class="form-title-icon" :src="require('@/static/CodeBuddyAssets/30858_5246/27.svg')"></el-image>
				<h3 class="form-title">新增收件人</h3>
			</div>

			<!-- Tab切换：送货上门 / 自提 -->
			<div class="addr-tab-bar">
				<div class="tab-options">
					<span class="addr-tab" :class="{ 'addr-tab-active': addrTab === 'deliver' }" @click="addrTab = 'deliver'">送货上门</span>
					<span class="addr-tab" :class="{ 'addr-tab-active': addrTab === 'pickup' }" @click="addrTab = 'pickup'">自提</span>
				</div>
				<div class="tab-underline" :class="{ 'underline-right': addrTab === 'pickup' }"></div>
				<div class="tab-divider"></div>
			</div>

			<!-- 表单主体 -->
			<div class="form-body">
				<!-- 左列 -->
				<div class="form-col">
					<div class="form-item">
						<label class="form-label">收件人</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.name" placeholder="请输入收件人名称" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">国家</label>
						<div class="form-input-wrap">
							<el-select v-model="formData.country" placeholder="请选择" size="large">
								<el-option v-for="item in countryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">城区</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.district" placeholder="请输入城区" size="large"></el-input>
						</div>
					</div>
				</div>

				<!-- 右列 -->
				<div class="form-col">
					<div class="form-item">
						<label class="form-label">手机号码</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.phone" placeholder="请输入手机号码" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">城市</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.city" placeholder="请输入城市" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">详细地址</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.address" placeholder="请输入详细地址" size="large"></el-input>
						</div>
					</div>
				</div>
			</div>

			<!-- 保存按钮 -->
			<div class="form-footer">
				<div class="save-btn">保存</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OrderPageAddrMsg',
	data() {
		return {
			addrTab: 'deliver',
			formData: {
				name: '',
				country: '',
				district: '',
				phone: '',
				city: '',
				address: ''
			},
			countryOptions: [
				{ value: 'china', label: '中国' },
				{ value: 'usa', label: '美国' },
				{ value: 'japan', label: '日本' },
				{ value: 'korea', label: '韩国' },
				{ value: 'uk', label: '英国' },
				{ value: 'germany', label: '德国' },
				{ value: 'france', label: '法国' },
				{ value: 'australia', label: '澳大利亚' },
				{ value: 'canada', label: '加拿大' },
				{ value: 'singapore', label: '新加坡' },
			]
		}
	},
	methods: {
		//
	}
}
</script>

<style lang="scss" scoped>
.addr-msg-page {
	width: 100%;
	min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 60px;
}

/* ===== 页面顶部条 ===== */
.page-top-bar {
	width: 1596px;
	height: 88px;
	background: #fff;
	border-radius: 12px;
	margin: 24px auto 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 32px;
	box-sizing: border-box;
}
.welcome-text {
	display: flex;
	align-items: baseline;
}
.wel-gray { font-size: 20px; color: #666; font-weight: 400; }
.wel-blue { font-size: 20px; color: #0096FF; font-weight: 500; margin-left: 4px; }
.top-actions { display: flex; align-items: center; }
.lang-text { font-size: 16px; font-weight: 500; color: #333; }
.action-gap { width: 1px; height: 18px; margin: 0 16px; }
.user-name { font-size: 18px; color: #333; margin-left: 8px; }
.member-no { font-size: 18px; color: #989FAC; margin-left: 8px; }
.cart-badge { margin-left: -6px; margin-bottom: 12px; width: 10px; height: 10px; }

/* ===== 面包屑 ===== */
.breadcrumb-bar {
	width: 1596px;
	margin: 16px auto 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 4px;
	box-sizing: border-box;
}
.bc-left { display: flex; align-items: center; }
.bc-label { font-size: 16px; color: #333; }
.bc-item { font-size: 16px; color: #666; margin: 0 4px; }
.bc-item.bc-active { color: #0096FF; }
.bc-arrow { width: 8px; height: 12px; margin: 0 8px; }
.bc-right { display: flex; align-items: center; cursor: pointer; }
.bc-back-text { font-size: 16px; color: #0096FF; }
.bc-back-icon { width: 8px; height: 12px; margin-left: 6px; }

/* ===== 表单卡片 ===== */
.form-card {
	width: 1596px;
	margin: 16px auto 0;
	background: #fff;
	border-radius: 12px;
	padding: 24px 24px 40px;
	box-sizing: border-box;
}

/* 表单标题 */
.form-title-row {
	display: flex;
	align-items: center;
	margin-bottom: 24px;
}
.form-title-icon { width: 4px; height: 16px; margin-right: 12px; }
.form-title { font-size: 20px; font-weight: 500; color: #333; margin: 0; }

/* Tab切换 */
.addr-tab-bar {
	position: relative;
	margin-bottom: 32px;
}
.tab-options {
	display: flex;
	align-items: center;
}
.addr-tab {
	font-size: 18px;
	cursor: pointer;
	margin-right: 32px;
	color: #7D7D89;
	font-weight: 400;
	padding-bottom: 15px;
	position: relative;
	transition: color 0.3s;
}
.addr-tab.addr-tab-active {
	color: #0096FF;
	font-weight: 500;
}
.tab-underline {
	position: absolute;
	bottom: 3px;
	left: 0;
	width: 72px;
	height: 4px;
	background: #0096FF;
	border-radius: 10px;
	transition: left 0.3s;
}
.underline-right {
	left: 114px;
}
.tab-divider {
	height: 1px;
	background: #F0F0F0;
	margin-top: -4px;
}

/* 表单主体 */
.form-body {
	display: flex;
}
.form-col {
	width: 728px;
	flex-shrink: 0;
}
.form-col:first-child {
	margin-right: 32px;
}
.form-item {
	margin-bottom: 24px;
}
.form-label {
	display: block;
	font-size: 16px;
	color: #333;
	font-weight: 400;
	margin-bottom: 10px;
}
.form-input-wrap {
	width: 100%;
}
.form-input-wrap ::v-deep .el-input__inner,
.form-input-wrap ::v-deep .el-select .el-input__inner {
	height: 54px;
	line-height: 54px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 16px;
	color: #333;
	padding-left: 24px;
}
.form-input-wrap ::v-deep .el-input__inner::placeholder {
	color: #999;
}
.form-input-wrap ::v-deep .el-select .el-input__inner::placeholder {
	color: #999;
}

/* 保存按钮 */
.form-footer {
	display: flex;
	justify-content: flex-end;
	margin-top: 8px;
}
.save-btn {
	width: 184px;
	height: 60px;
	background: #0096FF;
	border-radius: 10px;
	color: #fff;
	font-size: 18px;
	font-weight: 500;
	text-align: center;
	line-height: 60px;
	cursor: pointer;
	transition: background 0.3s;
}
.save-btn:hover {
	background: #33ABFF;
}
</style>
